import styled from 'styled-components';
import Theme from '../../../styles/models/theme';

export const FlagContainer = styled.div`
  width: 25vw;
`;

export const Flag = styled.input<{ theme: Theme; }>`
  font-size: 18px;
  padding: 15px;
  margin-top: 10px;
  margin-bottom: 10px;
  background: ${({theme}) => theme.white};
  border: 1px solid ${({theme}) => theme.inputBorder};
  box-sizing: border-box;
  border-radius: 8px;
  outline: none;
  width: 25vw;
  }
`;
